import { combineReducers } from "@reduxjs/toolkit";
import loginReducer from "./login/login";

const authReducer = combineReducers({
  login: loginReducer,
});

export default authReducer;
